import { Vue, Component } from 'vue-property-decorator'
import { asyncAlert } from '@/galaxy-cruise/components/AsyncAlert';
import NewWindow from './newwindow/index.vue'
import { store } from '@/store';
import { loginGuard, reloadMessages } from '@/galaxy-cruise/utils';
import { api } from '@/galaxy-cruise/api';
import { IMessage } from '@/galaxy-cruise/api_interface';

@Component
export default class extends Vue {
  static beforeEnter = loginGuard

  async openNewWindow() {
    await asyncAlert({ component: NewWindow })
  }

  get messages() {
    return store.galaxyCruise.all_messages
  }

  async mounted() {
    await reloadMessages()
  }

  async destroy(m: IMessage) {
    if (confirm(`Are you sure to delete message: ${m.ja_title}`)) {
      await api.default.delete(`../api/v1/messages/${m.id}`)
      await reloadMessages()
    }
  }

  async edit(m: IMessage) {
    await asyncAlert({ component: NewWindow, props: { message: m } })
  }
}
